import React from 'react';
import Section from 'components/common/Section';
import { Helmet } from 'react-helmet-async';

const Lizenz = () => {
  return (
    <>
      <Helmet>
        <title>Lizenz</title>
        <link rel="canonical" href="https://www.scanbox-product.de/Lizenz" />
        <meta
          name="description"
          content="Lizenzbedingungen für die Nutzung von Scanbox."
        />
      </Helmet>
      <Section className="bg-body-tertiary px-2 pt-5">
        <div className=" px-3">
          <h2 className="text-header fw-bold pb-4 mb-2">Lizenz</h2>
          <div>
            <h3 className=" text-center pb-1 pt-1 ">
              Endnutzer-Lizenzvereinbarung (EULA)
            </h3>
            <h3 className=" text-header pb-1 pt-1 ">
              1. Vertragsgegenstand und Definitionen
            </h3>
            <p className="text-600 text-justify pb-2">
              1.1 Diese Endnutzer-Lizenzvereinbarung (EULA) regelt die Nutzung
              der Software von ScanBox sowie der Dateien, die auf der Appliance
              enthalten sind.
            </p>
            <p className="text-600 text-justify pb-2">
              1.2 „Kunde“ im Sinne dieser EULA ist die natürliche oder
              juristische Person, öffentliche Stelle oder Behörde, die eine
              Maintenance für ScanBox von der DECOIT® GmbH & Co. KG („DECOIT®“)
              oder von einem Dritten erworben hat und im jeweiligen Vertrag als
              Kunde aufgeführt ist.
            </p>
          </div>
          <div>
            <h3 className=" text-header pb-1 pt-1 ">2 ScanBox Maintenance</h3>
            <p className="text-600 text-justify pb-2">
              2.1 Erzeugung von Instanzen: Die Erzeugung einer Instanz ist nur
              auf dem mit ausgelieferten System gestattet, welches sich im
              Eigentum des Kunden befindet oder dem Kunden zur ausschließlichen
              Nutzung zugewiesen ist.
            </p>
            <p className="text-600 text-justify pb-2">
              2.2 Nutzung der Software: Der Kunde hat das nicht-ausschließliche,
              zeitlich unbeschränkte, nicht-übertragbare Recht, die Dateien im
              Rahmen des Verwendungszwecks gemäß Ziffer 4 zu nutzen.
            </p>
            <p className="text-600 text-justify pb-2">
              2.3 Geschäftszweck: Die Nutzung der Dateien durch den Kunden ist
              beschränkt auf eigene Geschäftszwecke des Kunden. Die Nutzung der
              Dateien auch für Geschäftszwecke Dritter, z. B. für die
              Überwachung von IT-Infrastruktur, welche der Kunde für einen
              Dritten betreibt oder diesem zur Verfügung stellt, erfordert
              jedoch den Erwerb einer eigenen Maintenance.{' '}
            </p>
            <p className="text-600 text-justify pb-2">
              2.4 Dimensionierung: Das Nutzungsrecht ist beschränkt auf die im
              Rahmen der Maintenance zuletzt vereinbarte Anzahl der überwachten
              virtuellen oder physikalischen Hosts/Clients. Die Dimensionierung
              beinhaltet dabei die Schritte 50, 150 und 250 Hosts/Clients.
              Größere Umgebungen müssen projektiert werden.
            </p>
            <p className="text-600 text-justify pb-2">
              2.5 Nutzungsrechte: Hierüber hinausgehende Nutzungsrechte des
              Kunden (u.a. Vervielfältigung, Verbreitung und/oder öffentlichen
              Zugänglichmachung der Dateien sowie Nutzung über die
              Nutzungsbeschränkungen hinaus) bestehen nur, soweit diese
              ausdrücklich und in Textform (z. B. per Brief, E-Mail oder Fax)
              vereinbart wurden, oder soweit eine zwingende gesetzliche Regelung
              dies anordnet.
            </p>
            <p className="text-600 text-justify pb-2">
              2.6 Beendigung der Nutzungsrechte und Deinstallation: Mit Ablauf,
              Kündigung oder sonstiger Beendigung der Maintenance oder des
              Lizenzvertrages erlöschen sämtliche Nutzungsrechte des Kunden an
              ScanBox, soweit diese nicht auf zwingenden gesetzlichen Regelungen
              oder anwendbaren Open-Source-Lizenzen beruhen. Der Kunde ist
              verpflichtet, die Nutzung von ScanBox unverzüglich einzustellen
              und sämtliche Installationen einschließlich aller proprietären
              Bestandteile vollständig zu deinstallieren oder dauerhaft
              unbrauchbar zu machen. Open-Source-Komponenten sind nur insoweit
              ausgenommen, wie deren Lizenz eine weitere Nutzung ausdrücklich
              erlaubt. DECOIT ist berechtigt, nach vorheriger Ankündigung von
              mindestens 7 Tagen die Deinstallation von ScanBox auf den Systemen
              des Kunden manuell oder automatisiert durchzuführen. Grundlage
              hierfür ist der während der Maintenance bestehende administrative
              Zugriff auf das System. Der Kunde verpflichtet sich, diesen
              Zugriff für die Durchführung der Deinstallation bereitzustellen.
              Weitergehende gesetzliche Ansprüche von DECOIT bleiben unberührt.
            </p>
          </div>
          <div>
            <h3 className=" text-header pb-1 pt-1 ">3 Open-Source-Lizenzen</h3>
            <p className="text-600 text-justify pb-2">
              3.1 Die Software beinhaltet Open-Source-Komponenten: Für diese
              Dateien bestimmen sich die Nutzungsrechte ausschließlich nach der
              auf die jeweilige Datei anwendbaren Open-Source-Lizenz bzw. nach
              dem Urheberrechtsgesetz.
            </p>

            <p className="text-600 text-justify pb-2">
              3.2 Der Kunde ist auf der Grundlage der jeweils anwendbaren
              Open-Source-Lizenz bzw. aufgrund Gesetzes umfassend zur Nutzung
              der Dateien berechtigt, z. B. zum Kopieren, zur Installation und
              zum Laden in den Arbeitsspeicher. Insbesondere die Bearbeitung
              oder die Weitergabe von unbearbeiteten oder bearbeiteten Dateien
              können jedoch Lizenzpflichten auslösen. Der Kunde ist selbst dafür
              verantwortlich, die einschlägigen Lizenzbedingungen zu prüfen und
              deren Einhaltung sicherzustellen.
            </p>
          </div>
          <div>
            <h3 className=" text-header pb-1 pt-1 ">
              4 Verwendungszweck von ScanBox und Pflichten des Kunden
            </h3>

            <p className="text-600 text-justify pb-2">
              4.1 ScanBox ist für die Überwachung von IT-Systemen, Geräten und
              Anwendungen konzipiert worden. ScanBox ist nicht für die
              Überwachung von Systemen und deren Ausfall entwickelt worden, die
              zu einem Schaden für Leib und Leben führen kann.
            </p>

            <p className="text-600 text-justify pb-2">
              4.2 Bei der Einrichtung von ScanBox muss der Kunde je nach
              Kritikalität der zu überwachenden Systeme Maßnahmen treffen, um
              die Zuverlässigkeit der Überwachung sicherzustellen (z.B.
              Hochverfügbarkeit / Redundanz) und die Auswirkungen von möglichen
              Ausfällen zu minimieren.
            </p>

            <p className="text-600 text-justify pb-2">
              4.3 ScanBox kann dazu verwendet werden automatisierte Aktionen
              auszuführen. Automatisierte Aktionen können gravierende Probleme
              bis hin zum Ausfall von Systemen verursachen. Bei der Einrichtung
              solcher Aktionen muss der Kunde daher größte Vorsicht walten
              lassen, um die möglichen Auswirkungen fehlerhafter Alarme zu
              begrenzen.
            </p>

            <p className="text-600 text-justify pb-2">
              4.4 Der Betrieb des Systems muss dem aktuellen Stand der Technik
              entsprechen. Dazu gehören die Sicherung von Daten, insbesondere
              vor dem Einspielen von Updates oder Upgrades, sowie das Testen von
              Updates oder Upgrades vor ihrem produktiven Einsatz. Für
              Produktivsysteme sollten nur stabile Versionen der Software
              verwendet werden.
            </p>
          </div>

          <div>
            <h3 className=" text-header pb-1 pt-1 ">5 Schutz der Software</h3>
            <p className="text-600 text-justify pb-2">
              5.1 ScanBox ist ein Produkt der Firma DECOIT® GmbH & Co. KG. Die
              vorliegende EULA berechtigt den Kunden nicht, ScanBox oder Teile
              davon weiterzugeben. Die Weiterverbreitung ist nur auf der
              Grundlage einer gesonderten schriftlichen Vereinbarung zulässig.
              Wenn der Kunde Open-Source-Komponenten von ScanBox nach Maßgabe
              der jeweils anwendbaren Open-Source-Lizenz weitergibt, muss er
              vorher alle Produktdaten von ScanBox entfernen.
            </p>

            <p className="text-600 text-justify pb-2">
              5.2 Soweit nicht dem Kunden nach diesem Vertrag ausdrücklich
              Rechte eingeräumt worden sind, stehen alle Rechte an ScanBox (z.B.
              Rechte auf oder an Erfindungen) ausschließlich der DECOIT® zu. Der
              Kunde ist nicht berechtigt, ScanBox mit dem Ziel zu nutzen,
              Geschäftsgeheimnisse von der DECOIT® zu erlangen.
            </p>

            <p className="text-600 text-justify pb-2">
              5.3 Der Kunde wird alle Kopien von ScanBox sowie die Zugangsdaten
              für den Download-Bereich sorgfältig verwahren, um Missbrauch
              auszuschließen. Er wird die Software (gleich ob unverändert oder
              umgearbeitet) Dritten nur nach vorheriger schriftlicher Zustimmung
              von der DECOIT® zugänglich machen, wobei Open-Source-Komponenten
              von dieser Pflicht ausgenommen sind. Die Zugangsdaten dürfen nur
              an solche Mitarbeiter weitergegeben werden, die Administratoren
              oder Nutzer der Software sind.
            </p>

            <p className="text-600 text-justify pb-2">
              5.4 Dem Kunden ist es nicht gestattet, Urheberrechtsvermerke,
              Kennzeichen und/oder Kontrollnummern oder -zeichen von ScanBox zu
              verändern oder zu entfernen. Für Änderungen und Bearbeitungen der
              Open Source-Komponenten richten sich die Pflichten des Kunden
              alleine nach der anwendbaren Open-Source-Lizenz.
            </p>

            <p className="text-600 text-justify pb-2">
              5.5 Der Kunde darf Kopien der Software nur in dem Umfang
              herstellen und aufbewahren, der betrieblich erforderlich ist.
              Nicht mehr verwendete Kopien sind zu löschen. Dies gilt nicht für
              Open Source-Komponenten.
            </p>

            <p className="text-600 text-justify pb-2">
              5.6 Gibt der Kunde Datenträger, Speicher oder sonstige Hardware,
              auf denen Vertragsgegenstände (ganz oder teilweise, unverändert
              oder umgearbeitet) gespeichert sind, (i) an Dritte ab oder (ii)
              gibt er den unmittelbaren Besitz hieran auf, trägt er dafür Sorge,
              dass vorher die gespeicherte Software vollständig und dauerhaft
              gelöscht wird, wobei es dem Kunden freisteht, ob er auch die
              Open-Source-Komponenten löscht.
            </p>
          </div>
          <div>
            <h3 className=" text-header pb-1 pt-1 ">
              6 Anwendbares Recht und Gerichtsstand
            </h3>
            <p className="text-600 text-justify pb-2">
              6.1 Sollten einzelne Regelungen ganz oder teilweise unwirksam sein
              oder werden, so berührt dies die Wirksamkeit der übrigen
              Regelungen nicht. Die Parteien verpflichten sich vielmehr, die
              unwirksame Regelung durch eine wirksame Regelung zu ersetzen, die
              dem wirtschaftlich Gewollten am nächsten kommt.
            </p>

            <p className="text-600 text-justify pb-2">
              6.2 Es gilt deutsches Recht, mit Ausnahme von dessen Regelungen
              über das anzuwendende Recht, die zur Anwendung einer anderen
              Rechtsordnung führen würden. Die Geltung des UN-Übereinkommen über
              den internationalen Warenkauf (CISG) wird ausgeschlossen.
            </p>

            <p className="text-600 text-justify pb-2">
              6.3 Ausschließlicher Gerichtsstand für alle Streitigkeiten aus
              oder in Zusammenhang mit dem Vertrag einschließlich der
              Wirksamkeit des Vertrages ist Bremen, soweit gesetzlich zulässig.
              Der DECOIT® bleibt vorbehalten, den Kunden auch an dessen
              Geschäftssitz klageweise in Anspruch zu nehmen.
            </p>
          </div>
        </div>
      </Section>
    </>
  );
};

export default Lizenz;
